import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../Layout';
import SEO from '../components/SEO';
import News from '../sections/News';

import BarBio from '../components/BarBio';
import TwoColumnHero from '../components/TwoColumnHero';
import RestaurantsDelivery from '../sections/RestaurantsDelivery';

import RestaurantImage from '../assets/images/restaurant1.png'

const PortfolioPageTemplate = ({ data }) => {
  const mainImage = data.strapiRestaurants.mainImage
    ? data.strapiRestaurants.mainImage.childImageSharp.fluid.src
    : RestaurantImage

  return (
    <Layout>
      <SEO 
        title={data.strapiRestaurants.seo_page_title}
        keywords={data.strapiRestaurants.seo_keywords_list}
        canonical={`https://www.sandshospitality.com/portfolio/${data.strapiRestaurants.slug}/`}
        description={data.strapiRestaurants.shortDescription}
      />
      <TwoColumnHero
        image={mainImage}
        /*imageContent={
          <p>
            <span>{data.strapiRestaurants.location.Name}</span>
            discover
          </p>
        }*/
      >
        <BarBio
          restaurant={data.strapiRestaurants}
          name={data.strapiRestaurants.Name}
          desc={data.strapiRestaurants.description}
        />
        { data.strapiRestaurants.slug === 'bombay-dreams' &&
          <RestaurantsDelivery restaurant={data.strapiRestaurants} />
        }
        <News newsList={data.strapiRestaurants.promotions} small />
      </TwoColumnHero>
    </Layout>
  )
}

export default PortfolioPageTemplate

export const query = graphql`
  query PortfolioPageTemplate($id: String!) {
    strapiRestaurants(id: { eq: $id }) {
      id
      slug
      published
      Name
      seo_page_title
      seo_keywords_list {
        seo_keyword
      }
      description
      shortDescription
      lat
      lng
      Address
      phone
      email
      openingHours
      facebook
      instagram
      frequentDiner
      asiaMiles
      bookingsId
      fun_order
      slogan
      address_url
      OrderButtonText
      OrderButtonUrl
      type {
        Name
      }
      location {
        Name
      }
      mainImage {
        absolutePath
        childImageSharp {
          fluid {
            src
          }
        }
      }
      logo {
        absolutePath
        relativePath
        base
        extension
        childImageSharp {
          fluid {
            src
          }
        }
      }
      gallery {
        url
        width
        height
      }
      menus {
        file {
          id
          url
        }
        fileName
      }
      promotions {
        name
        endDate
        poster {
          childImageSharp {
            fluid {
              src
            }
          }
        }
        startDate
      }
    }
  }
`
